module.exports = __webpack_public_path__ + "static/9a5a3fd46115d293f659fb4129a7f036da1d2f3e11351c5a2041e79a25572b22-a5df2843e643ee0df2b3ae3c992b3f94.png";